import {createSlice} from '@reduxjs/toolkit'


export const controlsSlice = createSlice({
    name: 'controls',
    initialState: {
        searchPrompt: undefined,
        searchPromptAuto: false,
        page: 0,
        rowsPerPage: 25,
        offerTypeTab: true,
    },
    reducers: {
        saveSearchPrompt: (state, action) => {
            state.searchPrompt = action.payload;
            state.searchPromptAuto = true;
        },
        writeSearchPrompt: (state, action) => {
            state.searchPrompt = action.payload;
            state.searchPromptAuto = false;
        },
        setPage: (state, action) => {
            state.page = action.payload
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload
        },
        changeOfferTypeTab: (state, action) => {
            state.offerTypeTab = !state.offerTypeTab
            state.page = 0
        },
    },
})

export const {saveSearchPrompt, writeSearchPrompt, setPage, setRowsPerPage, changeOfferTypeTab} = controlsSlice.actions
export default controlsSlice.reducer
